

var _integration = require('./integration');

define(['angular', 'squid/index'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.lib.minibrowser', ['squid']).factory('$MiniBrowser', function ($rootScope, $q, $window, $Class, $populate, $CheckoutAppDataModel, $ReturnToMerchant, $logger, $util, $locale, $feature) {

        var MiniBrowser = $Class.extend('MiniBrowser', {

            isMiniBrowser: false,
            partnerIntegration: false,
            isDirectIntegration: false,

            initialize: function initialize(cancel_url) {
                this.isMiniBrowser = $rootScope.miniBrowser = $window.name && $window.name.indexOf('PPFrame') === 0 || $util.param('incontext') === '1';
                this.partnerIntegration = $rootScope.partnerIntegration = $window.name === 'PPFrameRedirect' || $util.param('nolegacy') === '1';

                //  this.nativeIntegration is true, whenever the query param native_xo=1 when hermes was launched
                this.nativeIntegration = $util.param('native_xo') === '1';

                this.isDirectIntegration = this.isMiniBrowser || this.partnerIntegration || Boolean($util.param('incontext')) || $window.location.pathname.indexOf('/checkoutnow') > -1;

                if (this.partnerIntegration) {
                    _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
                    $logger.info('partner_integration_flow');
                } else if (this.nativeIntegration && $feature('nativexoSupport')) {
                    // we are setting the flow to be native checkout type
                    // whenever the nativeIntegration flag is on
                    // setting this flow will enable the redirect_uri query param
                    // passed to hermes to override the merchant's redirect url
                    // on cancel or redirect after a successful payment

                    _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
                    $logger.info('nativexo_integration_flow');
                }

                if (this.isMiniBrowser && !this.partnerIntegration) {
                    var msg;

                    try {
                        msg = {
                            cancelUrl: cancel_url,
                            landingUrl: $window.location.href,
                            secureWindowmsg: $locale.content.scripts.secureWindowmsg
                        };
                    } catch (err) {
                        return $logger.error('minibrowser_msg_construction_failed', {
                            error: err
                        });
                    }

                    if (!$ReturnToMerchant.postToMerchant(msg)) {
                        $logger.error('minibrowser_post_failed');
                    }
                }
            }
        });

        return new MiniBrowser();
    });
});

_integration.$integration;

_integration.$FLOWS;


//////////////////
// WEBPACK FOOTER
// ./js/lib/miniBrowser.js
// module id = ./js/lib/miniBrowser.js
// module chunks = 1